import { render, staticRenderFns } from "./CompanyEmployeesCard.vue?vue&type=template&id=fa123f20"
import script from "./CompanyEmployeesCard.vue?vue&type=script&lang=ts"
export * from "./CompanyEmployeesCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports